export const TEST_IDS = {
  optionCarrier: 'option-card-carrier',
  optionDispatcher: 'option-card-dispatcher',
  optionDispatcherEmail: 'option-card-dispatcher-email',
  optionDispatcherPhone: 'option-card-dispatcher-phone',
  optionReporter: 'option-card-reporter',
  optionReporterExternal: 'option-card-external-reporter',
  optionOpsRep: 'option-card-ops-rep',
  optionPcm: 'option-card-pcm',
}
